import React from 'react';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import PropTypes from 'prop-types';
import { IconHelp } from '../theme';

const TextInputHelp = ({ name, layout, label, buttonCallback, tooltip, error, ...rest }) => <>
    <Row className='form-group'>
        <Col xs={layout[0]} style={{fontWeight:'bold'}} ><label htmlFor={name}>{label}</label></Col>
        <Col xs={layout[1]}>
        <input
            type="text"
            id = {name}
            name={name}
            className="form-control"
            {...rest}
        />
        </Col> 
        <Col xs={layout[2]}><IconHelp tooltip={tooltip}/></Col>
    </Row>
    <Row><Col xs='12'>{error && <div className="alert alert-danger">{error}</div>}</Col></Row>
  </>;

TextInputHelp.defaultProps = {
    layout: [2,8,2]
  };

TextInputHelp.propTypes = {
    name: PropTypes.string,
    label: PropTypes.string,
    placeholder: PropTypes.string,
    buttonCallback: PropTypes.func,
    value: PropTypes.string,
    tooltip: PropTypes.string,
    layout: PropTypes.array,
    error: PropTypes.string
  };

export default TextInputHelp;